module.exports = __webpack_public_path__ + "static/media/title.9f808e8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/title.svg
// module id = 181
// module chunks = 0